<form [formGroup]="updateUserForm" (ngSubmit)="onUpdateUser()">
  <div class="main-card">
    <div class="card-header">
      <a class="main-btn back-btn" [routerLink]="['./../']"
        ><i class="pi pi-angle-left m-0"></i
      ></a>
      <button
        class="main-btn"
        type="submit"
        [ngClass]="{ disabled: !updateUserForm.valid }"
        [disabled]="!updateUserForm.valid"
      >
        Snimi <i class="pi pi-save"></i>
      </button>
    </div>
    <h3 class="card-title">Dodaj korisnika</h3>

    <div class="card-body">
      <div class="grid">
        <div class="col-4">
          <div class="field">
            <label>Ime</label>
            <input type="text" formControlName="fname" pInputText />
          </div>

          <div class="field">
            <label>Prezime</label>
            <input type="text" formControlName="lname" pInputText />
          </div>

          <div class="field">
            <label>Uloga</label>
            <p-dropdown
              [options]="roles"
              optionLabel="name"
              formControlName="role_id"
              optionValue="role_id"
            ></p-dropdown>
          </div>

          <div class="field">
            <label>Email</label>
            <input type="email" formControlName="email" pInputText />
          </div>
        </div>

        <div class="col-4">
          <div class="field">
            <label>Korisničko ime</label>
            <input type="text" formControlName="username" pInputText />
          </div>

          <div class="field">
            <label>Šifra</label>
            <button type="button" class="main-btn" (click)="onEditPassword()">
              Promeni šifru
            </button>
          </div>

          <ng-container *ngIf="editedPassword">
            

            <div class="field">
              <label>Šifra</label>
              <input type="password" formControlName="password" pInputText />
            </div>

            <div class="field">
              <label>Ponovi šifru</label>
              <input
                type="password"
                formControlName="password_confirmation"
                pInputText
              />
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</form>
